import useReveal from '../../hooks/useReveal';

const HomeHowItWorksSection = () => {
  const [ref, visible] = useReveal();

  const steps = [
    { num: "01", title: "Discover", desc: "Browse vetted premium properties across top markets. Each listing is thoroughly reviewed by our acquisition team." },
    { num: "02", title: "Invest", desc: "Purchase fractional shares from $500. Pay with your CoOwn USD wallet (card-funded) or USDC/ALGO on Algorand — same checkout, same share ledger." },
    { num: "03", title: "Earn", desc: "Receive quarterly distributions from rental income and appreciation. Track everything in your personalized dashboard." },
    { num: "04", title: "Exit", desc: "Sell your shares on our secondary market or hold until the property disposition. Flexibility meets returns." },
  ];

  return (
    <section ref={ref} className="home-process" aria-labelledby="home-process-heading">
      <div className="home-process-inner">
        <div className="home-process-header">
          <div className={`reveal-up ${visible ? "visible" : ""} home-process-eyebrow`}>
            <div className="home-process-eyebrow-line"></div>
            <span className="home-process-eyebrow-text">The Process</span>
            <div className="home-process-eyebrow-line home-process-eyebrow-line--reverse"></div>
          </div>
          <h2
            className={`reveal-up delay-1 ${visible ? "visible" : ""} home-process-title`}
            id="home-process-heading"
          >
            How CoOwn Works
          </h2>
        </div>

        <div className="home-process-steps">
          <div className="home-process-line" aria-hidden="true">
            <div
              className={`home-process-line-draw ${visible ? "visible" : ""}`}
              style={{ transitionDelay: "0.5s" }}
            ></div>
          </div>

          {steps.map((step, i) => (
            <div
              key={step.num}
              className={`reveal-up delay-${i + 1} ${visible ? "visible" : ""} home-process-step`}
            >
              <div className="home-process-step-badge" aria-hidden="true">
                <span className="home-process-step-num">{step.num}</span>
              </div>
              <h3 className="home-process-step-title">{step.title}</h3>
              <p className="home-process-step-desc">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeHowItWorksSection;
